import {Component, OnInit} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import { Order } from '../../../modules/patients/patient-details/medicines/patient-subscription-details/models/order.model';

@Component({
	selector: 'aga-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
	iconUri: string = '/assets/icons/svg/ic_Warning-Info_24x24.svg';
	isWarning: boolean;
	message: string;
	innerHtml: string;
	leftButtonText: string;
	rightButtonText: string;
	hideRightButton: boolean;
	hideLeftButton: boolean;
	invertButtonColors: boolean;
	onLeftButtonClick: Function;
	onRightButtonClick: Function;
	hideIcon: boolean = false;
	hideDropdown: boolean = false;
	isSubscriptionDelay: boolean;
	minSubscriptionDelayDate: Date;
	disabledDatesBeforeCurrentNextPayment: Date[];
	subscriptionNextPaymentDate: string;
	nextPaymentForm: UntypedFormGroup;
	selectedOption = 1; 
  options = [1,2,3,4,5,6,7,8,9,10,11,12]; 
	isRefundSubscriptionOrder: boolean;
	order: Order;

	constructor(private translateService: TranslateService) {
	}

	onSelectChange(event: Event) {
		const target = event.target as HTMLSelectElement;
		this.selectedOption = Number(target.value);
	}

	ngOnInit(): void {
		if (!this.leftButtonText) {
			this.leftButtonText = this.translateService.instant('genericButtons.no');
		}
		if (!this.rightButtonText) {
			this.rightButtonText = this.translateService.instant('genericButtons.yes');
		}
		this.isWarning = this.iconUri.includes('Warning-Question');
		
		if (this.isSubscriptionDelay) {
			this.nextPaymentForm = new UntypedFormGroup({
				selectedNextPaymentDate: new UntypedFormControl(null, Validators.required)
			});
			
			const today = new Date();
			const minimumDate = new Date(today);
			minimumDate.setDate(minimumDate.getDate() + 3);
			this.minSubscriptionDelayDate = minimumDate;

			const aDayBeforeTheNextPayment = new Date(this.subscriptionNextPaymentDate);
			const twoDaysBeforeTheNextPayment = new Date(this.subscriptionNextPaymentDate);
			aDayBeforeTheNextPayment.setDate(aDayBeforeTheNextPayment.getDate() - 1);
			twoDaysBeforeTheNextPayment.setDate(twoDaysBeforeTheNextPayment.getDate() - 2);
			this.disabledDatesBeforeCurrentNextPayment = [new Date(this.subscriptionNextPaymentDate), aDayBeforeTheNextPayment, twoDaysBeforeTheNextPayment];
		}
	}
	
	isConfirmButtonDisabled(): boolean {
		return this.isSubscriptionDelay && !this.nextPaymentForm.valid;
	}
}
